import { adminApiRequest } from "../../utils/apiUtils";
export interface InterviewResponse {
  id: number;
  title: string;
  year: number;
  month: number;
  coverImageUrl: string;
  createdAt: string;
  content: string;
}
export const InterviewAPI = {
  getInterview: () => {
    return adminApiRequest.get("/interview").then((res) => res.data);
  },
  createInterview: (request: FormData) => {
    return adminApiRequest
      .post("/interview", request, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data);
  },
  updateInterview: (request: FormData, id: number) => {
    return adminApiRequest
      .put(`/interview/${id}`, request, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data);
  },
  deleteInterview: (id: number) => {
    return adminApiRequest.delete(`/interview/${id}`).then((res) => res.data);
  },
  uploadInterviewImage: (request: FormData) => {
    return adminApiRequest
      .post("/interview/upload-image", request, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data);
  },
};
